import { Flex, Text } from "@gravity-ui/uikit";

import { StepProps } from "../Stepper.types";

export const StepperItemContent = ({ title, description, time }: StepProps) => {
  return (
    <Flex
      alignItems={"center"}
      justifyContent={"space-between"}
      gap={8}
      style={{
        backgroundColor: "var(--g-color-base-generic)",
        padding: 12,
        borderRadius: 10,
      }}
      width={"100%"}
    >
      <Flex direction={"column"} gap={2} maxWidth={"80%"}>
        <Text variant="subheader-2" style={{ wordBreak: "keep-all" }}>
          {title}:
        </Text>
        <Text variant="caption-2" color="secondary">
          {description}
        </Text>
      </Flex>
      <Text>{new Date(time).toLocaleString()}</Text>
    </Flex>
  );
};
